module.exports = __webpack_public_path__ + "static/img/icon_yw.1d2fb644.svg";